// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"Gallery_postContainer__2Mpo4","title":"Gallery_title__27I3-","content":"Gallery_content__1LL_z"};